import React, { useState, useRef, useEffect } from "react";
import "./printInspectionReport.scss";
import { Row, Table, Container } from "react-bootstrap";
import { FileText } from 'react-bootstrap-icons';
import InnerLoading from "components/InnerLoading";
import logo from "../../assets/images/logo.png";
import ReactToPrint from "react-to-print";
import NavBar from "components/MainNavbar";
import {displayFormattedDateTimeWithOutDay, handleDownloadFile, isImage } from "utils/utility";
import _ from "lodash";
import ReactApexChart  from "react-apexcharts";
import { fetchInspectionMachineHours } from "services/inspection";
import { INSPECTION_ITEM_PASS_OR_FAIL_TYPE } from "utils/constants";

const PrintInspectionReport = () => {
  const [parsedData, setParsedData] = useState();
  const [machineHoursData, setMachineHoursData] = useState([]);
  const contentRef = useRef(null);
  
  const [loading,setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const dataString = localStorage.getItem("inspectionReportData");
    if (dataString) setParsedData(JSON.parse(dataString));
    setLoading(false);
  }, []);
  const fetchMachineHours = async () => {
    setLoading(true);
    const data = await fetchInspectionMachineHours(parsedData.id)
    if (data) {
      const updatedData = data.map(item => {
        const updatedLabels = item?.labels?.map(label => {
            const [day, month, year] = label?.split('/');
            return `${month}/${day}/${year}`;
        });
        return { ...item, labels: updatedLabels };
    });
      setMachineHoursData([...updatedData])
    }
    setLoading(false);
  }
  useEffect(() => { 
    if(!_.isEmpty(parsedData)) {
      fetchMachineHours()
    }
  }, [parsedData]);
  const getChartOptions = (labels) => {
    return {
      chart: {
        height: 350,
        type: 'line',
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      xaxis: {
        type: 'category',
        categories: labels,
      }
    }
  }
  const getChartSeries = (values) => {
    return  [{
        name: "Series-1",
        data: values
    }]
  }
  return (
    <Container fluid>
      <NavBar />
      <Row>
        {loading ? (
          <InnerLoading show={loading} />
        ) : parsedData?.itemResults?.length > 0 ? (
          <>
            <div>
              <ReactToPrint
                trigger={() => (
                  <button className="mt-5 mx-auto btn btn-outline-secondary d-flex align-items-center text-uppercase shadow-none">
                    <i className="me-2 fas fa-print"></i>
                    Print Inspection Report
                  </button>
                )}
                content={() => contentRef.current}
                pageStyle="@page { size: A4; margin: 0; } @media print { body { margin: 0; } * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; } }"
              />
            </div>
            <div className="reportDetailContainer" ref={contentRef}>
              <img
                src={logo}
                height={100}
                width={"auto"}
                className="mt-5 mb-5  mx-auto d-block"
              />
              <p className="para">
                <span className="heading">District: </span>
                {`${parsedData?.districtName || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Building: </span>
                {`${parsedData?.buildingName || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Section: </span>
                {`${parsedData?.section || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Inspected By: </span>
                {`${parsedData?.inspectedByName || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Room: </span>
                {`${parsedData?.roomName || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Score: </span>
                {`${parsedData?.score || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Cleaner Name: </span>
                {`${parsedData?.cleanerName || "-"}`}
              </p>
              <p className="para">
                <span className="heading">Created On: </span>
                      {`${
                  displayFormattedDateTimeWithOutDay(parsedData?.created)|| "-"
                }`}
              </p>
              <p className="para">
                <span className="heading">Last Updated: </span>
                      {`${
                  displayFormattedDateTimeWithOutDay(parsedData?.Updated)|| "-"
                }`}
              </p>
              <h5 className="py-4"><i>Pass or Fail Answer</i></h5>
              <Table bordered className="inspection-item-table">
                <thead>
                  <tr>
                    <th>Inspection Item</th>
                    <th>Note</th>
                    <th>Result</th>
                    <th>Files</th>
                  </tr>
                </thead>
                <tbody>
                  {parsedData?.itemResults.filter((item)=>item.result!==3 && item.inspectionItemType == INSPECTION_ITEM_PASS_OR_FAIL_TYPE)?.map((item) => {
                    return (
                      <tr>
                        <td> {item?.inspectionItem} </td>
                        <td> {item?.note} </td>
                        <td> {item.result === 0 ? "Fail" :item?.result===3?"NA": "Pass"}</td>
                        <td className="image-row">
                          <div className="d-flex  align-content-start flex-wrap justify-content-lg-start justify-content-center">
                          {item.files.map((file, index) => (
                            <div key={index} className="mb-2">
                            {isImage(file.file)? <img
                              key={index}
                              src={file.file}
                              className="d-block mb-2 inspection-item-image pe-2"
                            /> : <a  href={file.file} onClick={() => handleDownloadFile(file.file, file.name)}><FileText size={150} />
                              <div className="file-title" >
                                {file.name || ""}
                              </div>
                            </a>}
                            </div>
                          ))}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <h5 className="mt-4 mb-1"><i>Numerical Answer</i></h5>
              <Table bordered className="inspection-item-table">
                <thead>
                  <tr>
                    <th>Inspection Item</th>
                    <th>Values</th>
                  </tr>
                </thead>
                <tbody>
                  {machineHoursData.map((item, index)=> {
                    return <tr key={index}>
                      <td> {item.inspectionItem} </td>
                      <td className="text-center">  
                        <ReactApexChart
                            options={getChartOptions(item.labels)}
                            series={getChartSeries(item.values)}
                            type="line"
                            height="300"
                            width="600"
                          />
                      </td>
                    </tr>
                  })}
                </tbody>
              </Table>
              <h5 className="mt-3 mb-1"><i>Inspection Notes</i></h5>
              <p>{parsedData.note || "-"}</p>
              <h5 className="mt-3 mb-1"><i>Inspection Files</i></h5>
              <div className="d-flex  align-content-start flex-wrap justify-content-lg-start justify-content-center">
                {parsedData.inspectionFiles?  parsedData.inspectionFiles.map((file, index) => (
                  <div key={index} className="mb-2">
                  {isImage(file.file)? <><img
                    key={index}
                    src={file.file}
                    className="d-block mb-2 inspection-item-image pe-2"
                  /> <div className="file-title" >
                      {file.name || ""}
                    </div></>: <a  href={file.file} onClick={() => handleDownloadFile(file.file, file.name)}><FileText size={150} />
                    <div className="file-title" >
                      {file.name || ""}
                    </div>
                  </a>}
                  </div>
                )): "-"}
                </div>
            </div>
          </>
        ) : (
          <p className="text-center text-danger"> Some Thing Went Wrong</p>
        )}
      </Row>
    </Container>
  );
};

export default PrintInspectionReport;
